import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { provideComponent, useDataItem } from "scrivito"
import { KpiCard } from "shared/ui/kpi-card/KpiCard"

import { RegistrationKpiWidget } from "./RegistrationKpiWidgetClass"

provideComponent(RegistrationKpiWidget, () => {
  const { t } = useTranslation()
  const kpiData = useDataItem("UserKPIs")

  const donutChart = useMemo(() => {
    return {
      centerText: kpiData?.get("totalExternalUsers") as number,
      data: [
        {
          label: t("KPIs.Registration.Email"),
          value: kpiData?.get("emailUsers") as number
        },
        {
          label: t("KPIs.Registration.Google"),
          value: kpiData?.get("googleUsers") as number
        },
        {
          label: t("KPIs.Registration.LinkedIn"),
          value: kpiData?.get("linkedinUsers") as number
        },
        {
          label: t("KPIs.Registration.Microsoft"),
          value: kpiData?.get("microsoftUsers") as number
        }
      ].filter(item => typeof item.value === "number")
    }
  }, [kpiData])

  const externalSignUpCount = useMemo(() => {
    return {
      last7Days: kpiData?.get("externalSignUpLast7Days") as number,
      last30Days: kpiData?.get("externalSignUpLast30Days") as number
    }
  }, [kpiData])

  return (
    <KpiCard.Root>
      <KpiCard.Title title={t("KPIs.Registration.ExternalRegistration")} />
      <KpiCard.DonutChart
        data={donutChart.data}
        centerText={donutChart.centerText}
      />
      <KpiCard.Title title={t("KPIs.Registration.NewRegistration")} />
      <KpiCard.DataList
        data={[
          { label: t("KPIs.Last7Days"), value: externalSignUpCount.last7Days },
          { label: t("KPIs.Last30Days"), value: externalSignUpCount.last30Days }
        ]}
      />
    </KpiCard.Root>
  )
})
